export default {
  getModules: state => state.modules,
  getDefaultModule: state => state.defaultModule,
  getModulesAllowed: state => state.modulesAllowed,
  currentModuleName: state => state.modulesAllowed.find(x => x.id === state.defaultModule).folder
};
